import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

// Material components
import { Box, Typography, useMediaQuery } from "@material-ui/core";

// Styles
import useStyles from "../../../assets/styles/components/cards/components/statusCourseBarStyle";

const IN_PROGRESS = 1;
const FINISHED = 2;
const NOT_APPROVED = 3;
const BLOCKED = 4;

const StatusCourseBar = ({
  type,
  approved = false,
  blocked,
  blockedByCourseName,
}) => {
  const isResponsive = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const classes = useStyles();
  let status = null;
  let label = "";

  // Prioridad 1: Si está bloqueado, mostrar estado bloqueado
  if (blocked) {
    status = BLOCKED;
    label = blockedByCourseName
      ? `${blockedByCourseName} requerida`
      : "Bloqueado";
  } else {
    // Prioridad 2: Determinar estado según tipo y aprobación
    if (type === IN_PROGRESS) {
      status = IN_PROGRESS;
      label = "En progreso";
    } else if (type === FINISHED && approved) {
      status = FINISHED;
      label = "Finalizado";
    } else {
      status = NOT_APPROVED;
      label = "Reprobado";
    }
  }

  return (
    <Box
      id="status-course-bar-root"
      className={clsx(classes.rootStatusCourseBar, {
        [classes.inProgressCourse]: status === IN_PROGRESS,
        [classes.finishedCourse]: status === FINISHED,
        [classes.reprobateCourse]: status === NOT_APPROVED,
        [classes.blockedCourse]: status === BLOCKED,
      })}
    >
      <Typography
        variant={isResponsive ? "caption" : "body2"}
        className={clsx("semi-bold", isResponsive && "variant-caption-sm")}
      >
        {label}
      </Typography>
    </Box>
  );
};

StatusCourseBar.propTypes = {
  type: PropTypes.oneOf([IN_PROGRESS, FINISHED]),
  approved: PropTypes.bool,
  blocked: PropTypes.bool,
  blockedByCourseName: PropTypes.string,
};

export default StatusCourseBar;
